<template>
  <div class="login-container">
    <img src="@/assets/images/chatnav_logo.svg" alt="ChatNav Logo" class="chatnav-logo" />
    <h1>ChatNav Hub Login</h1>
    <div v-if="error" class="flash-messages">
      <div class="flash-message">{{ error }}</div>
    </div>
    <form class="login-form" @submit.prevent="onSubmit">
      <input v-model="username" type="email" placeholder="Email" required />
      <input v-model="password" type="password" placeholder="Password" required />
      <button type="submit">{{ isRegister ? 'Register' : 'Sign In' }}</button>
    </form>
    <!-- Registration disabled - contact admin for account creation -->
    <!-- <a class="toggle-link" href="#" @click.prevent="toggleMode">
      {{ isRegister ? 'Already have an account? Sign In' : "Don't have an account? Register" }}
    </a> -->
  </div>
</template>

<script>
import { setTokens } from '@/services/auth';

export default {
  name: 'LoginRegister',
  data() {
    return {
      username: '',
      password: '',
      isRegister: false,
      error: ''
    }
  },
  methods: {
    async onSubmit() {
      this.error = '';
      const apiBase = process.env.VUE_APP_API_BASE_URL;
      const endpoint = this.isRegister
        ? `${apiBase}/api/register`
        : `${apiBase}/api/login`;
      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username: this.username, password: this.password })
        });
        const data = await response.json();
        if (!response.ok) {
          // FastAPI validation errors are in data.detail (array of error objects)
          if (Array.isArray(data.detail) && data.detail[0]?.msg) {
            this.error = "Please enter a valid email address.";
          } else if (data.detail) {
            this.error = data.detail;
          } else {
            const errPrefix = this.isRegister ? 'Registration' : 'Login';
            this.error = `${errPrefix} failed. Please check your input.`;
          }
        } else {
          setTokens(data.access_token, data.refresh_token);
          this.$router.push('/home');
        }
      } catch (e) {
        this.error = 'Server error. Please try again.';
      }
    },
    toggleMode() {
      this.isRegister = !this.isRegister;
      this.error = '';
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/login-register.scss";
</style>
